<div class="container">
  @if (isAgreementVisible() === false) {
  <div>
    <app-agreement-not-ready [workerId]="agreement.WorkerId"></app-agreement-not-ready>
  </div>
  } @if (isAgreementVisible() === true) {
  <div>
    @if (agreement != null) {
    <form>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
        <h1>{{ 'WorkerAgreementDetails' | translate }} - {{ agreement.FullName }}</h1>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          @if (isAgreementImported) {
          <mat-icon class="agreement-info-icon icon-lg" [matTooltip]="'WAD-IsImportedAgreementInfo' | translate">info</mat-icon>
          } @if (isAgreementFileButtonVisible) {
          <button mat-raised-button color="primary" (click)="onShowAgreementClick()">
            {{ 'WAD-ShowAgreement' | translate }}
          </button>
          } @if (isPIT2ButtonVisible()) {
          <button mat-raised-button color="primary" (click)="onShowPIT2Click()">
            {{ 'WAD-ShowPIT2' | translate }}
          </button>
          } @if (isPpkCancellationStatementButtonVisible()) {
          <button mat-raised-button color="primary" (click)="onShowPpkCancellationStatementClick()">
            {{ 'WAD-ShowPpkCancellationStatement' | translate }}
          </button>
          }
          <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'WAD-Actions' | translate }}</button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onDownloadAgreementClick()" [disabled]="!isAgreementFileButtonVisible">
              {{ 'WAD-DownloadAgreement' | translate }}
            </button>
            @if (isAddAnnexButtonVisible()) {
            <div *hasPermissionToModule="moduleNames.Annex; workerId: agreement.WorkerId">
              <button mat-menu-item (click)="onAddAnnexClick()">
                {{ 'AddAnnex' | translate }}
              </button>
            </div>
            } @if (!isAgreementRelatedToUser) {
            <button mat-menu-item [disabled]="!isExtendButtonEnabled()" (click)="onExtendAgreementClick()">
              {{ 'ExtendAgreement' | translate }}
            </button>
            }
            <div [matTooltip]="!isCancelButtonEnabled() ? ('WAD-CancelAgreementTooltip' | translate) : ''">
              <button mat-menu-item [disabled]="!isCancelButtonEnabled()" (click)="onCancelAgreementClick()">
                {{ 'WAD-CancelAgreement' | translate }}
              </button>
            </div>
            @if (isDeleteButtonVisible()) {
            <div [matTooltip]="deleteButtonTooltip()">
              <button mat-menu-item [disabled]="!isDeleteButtonEnabled()" (click)="onDeleteAgreementClick()">
                {{ 'WAD-DeleteAgreement' | translate }}
              </button>
            </div>
            }
            <div [matTooltip]="agreement.HasAtLeastOneSettledTimesheet ? ('YouCannotVoidAgreementWithAtLeastOneSettledTimesheet' | translate) : ''">
              @if (isVoidAgreementButtonVisible()) {
              <button mat-menu-item [disabled]="isVoidAgreementButtonDisabled()" (click)="onVoidAgreementClick()">
                {{ 'WAD-VoidAgreement' | translate }}
              </button>
              }
            </div>
            @if (isUndoVoidingAgreementButtonVisible()) {
            <button mat-menu-item (click)="onUndoVoidingAgreementClick()">
              {{ 'WAD-UndoVoidingAgreement' | translate }}
            </button>
            } @if (isTerminateAgreementButtonVisible()) {
            <button mat-menu-item (click)="onTerminateAgreementClick()">
              {{ 'TerminateAgreement' | translate }}
            </button>
            }
            <button mat-menu-item (click)="onShowWorkerProfileClick()">{{ 'SAW-SeeWorkerProfile' | translate }}</button>
            <button
              mat-menu-item
              [visibleWithPermissions]="['ReplaceAgreement']"
              [disabled]="!isReplaceAgreementButtonEnabled()"
              (click)="onReplaceAgreementClick()"
            >
              {{ 'ReplaceWorkerAgreement' | translate }}
            </button>
          </mat-menu>
        </div>
      </div>
      @if (!!(replacedByMessage$ | async)) {
      <alert [message]="replacedByMessage$ | async" alertType="info"></alert>
      }
      <div class="content-card">
        <h2 class="content-card__header">{{ 'WAD-Documents' | translate }}</h2>
        <table>
          <tbody>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'WAD-Agreement' | translate }}</td>
              <td class="key-value-row__value">
                @if (isAgreementFileButtonVisible) {
                <a class="dark-anchor" href="javascript:void(0)" (click)="onShowAgreementClick()" download>
                  {{ fileName }}
                </a>
                } @else {
                <span>{{ agreementName }}</span>
                }
              </td>
            </tr>
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'WAD-AgreementStatus' | translate }}</td>
              <td class="key-value-row__value">
                @if (isLoadingIndicatorVisible) {
                <app-custom-pacman-spinner size="xs" class="spinner">
                  <div class="spinner-label">{{ agreement.AgreementStatus }}</div>
                </app-custom-pacman-spinner>
                } @else {
                {{ agreement.AgreementStatus }}
                }
              </td>
            </tr>
            @if (agreement.AgreementVoidingReason) {
            <tr class="key-value-row">
              <td class="key-value-row__key">{{ 'AgreementVoidingReason' | translate }}</td>
              <td class="key-value-row__value">{{ agreement.AgreementVoidingReason }}</td>
            </tr>
            }
          </tbody>
        </table>
        @if (agreement.HasPreliminaryMedicalExaminationRequirements) {
        <div class="checkbox-row">
          <mat-checkbox [checked]="agreement.IsPreliminaryMedicalExaminationRequired" disabled>
            {{ 'WAD-PreliminaryMedicalExaminationRequirements' | translate }}
          </mat-checkbox>
        </div>
        }
      </div>
      @if (filteredAnnexesBaseData.length > 0) {
        <div class="content-card">
          <h2 class="content-card__header">{{ 'WAD-Annexes' | translate }}</h2>

          <div class="annexes-list">
            @for (annex of filteredAnnexesBaseData; track annex.AnnexId) {
              <div
                class="annex-row"
                (click)="navigateToAnnex(annex.AnnexId)"
                tabindex="0"
                role="link">
                {{ 'Annex.AnnexFromDate' | translate }} {{ annex.ConclusionDate | date:'yyyy-MM-dd' }}
                {{ 'Annex.EffectiveFrom' | translate }} {{ annex.StartDate | date:'yyyy-MM-dd' }} ({{ annex.AnnexStatus }})
                <app-annex-imported-badge [visible]="annex.IsImported" />
              </div>
            }
          </div>
        </div>
      }
      @if (isLegalizationFieldVisible()) {
      <div
        [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
        class="content-card"
      >
        <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
        <app-legalization-status-info
          [element]="workerAgreementLegalizationData"
          [size]="'large'"
          [showStatusText]="true"
          [showTooltip]="false"
        ></app-legalization-status-info>
      </div>
      }

      <!-- Agreement details using shared component -->
      <app-worker-agreement-details-shared [agreement]="agreement" [annexesData]="annexesData"> </app-worker-agreement-details-shared>

      @if (agreement.AgreementStatusId == WorkerAgreementStatusEnum.Terminated) {
      <div class="content-card">
        <app-terminate-agreement-section [agreementTerminationInfo$]="agreementTerminationInfo$"></app-terminate-agreement-section>
      </div>
      } @if ((listOfConsentTypes$ | async)?.length > 0) {
      <div class="content-card">
        @for (consentType of listOfConsentTypes$ | async; track consentType) {
        <form fxLayout="column" fxLayoutGap="10px" [formGroup]="consentsFormGroup">
          <!-- Consent -->
          @if (consentsFormGroup.controls['consent_' + consentType.Id]) {
          <div class="checkbox-value" fxLayout="row" fxLayoutGap="10px">
            <mat-checkbox [formControlName]="'consent_' + consentType.Id" (change)="toggleConsent($event, consentType.Id)" #cc></mat-checkbox>
            <label [class.required-consent]="!cc.checked && consentType.IsRequired">
              @if (isConsentExpanded(consentType.Id)) {
              <span>{{ consentType.Name | translate }}</span>
              } @if (!isConsentExpanded(consentType.Id)) {
              <span>{{ consentType.Name | translate | slice : 0 : 100 }}</span>
              }
            </label>
            <div class="toggler" (click)="toggleLabel(consentType.Id)">
              @if (isConsentExpanded(consentType.Id)) {
              <mat-icon class="icon">expand_less</mat-icon>
              } @if (!isConsentExpanded(consentType.Id)) {
              <mat-icon class="icon">expand_more</mat-icon>
              }
            </div>
          </div>
          }
        </form>
        }
        <!-- RODO -->
        @if (rodoClause$ | async; as clause) {
        <div>
          <a [href]="clause.File" target="_blank" rel="noopener noreferrer">{{ clause.Name }}</a>
        </div>
        } @if (remoteWorkClause$ | async; as clause) {
        <div>
          <a [href]="clause.File" target="_blank" rel="noopener noreferrer">{{ clause.Name }}</a>
        </div>
        }
      </div>
      }
      <!-- ALERT IF REPLACEMENT EXISTS -->
      @if (!!(replacementMessage$ | async)) {
      <alert [message]="replacementMessage$ | async" alertType="warning"></alert>
      }
      <!-- SMS Verification Code Approval Section -->
      @if (isSmsApprovalSectionVisible()) {
      <div class="content-card mat-space-bottom">
        <h2 class="content-card__header">{{ 'WAD-VerificationCodeApproval' | translate }}</h2>
        <form fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" [formGroup]="verificationCodeFormGroup">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{ 'VerificationCode' | translate }}</mat-label>
            <input matInput placeholder="{{ 'VerificationCode' | translate }}" formControlName="verificationCode" minlength="8" maxlength="8" />
            @if (verificationCode.invalid && verificationCode.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
            }
          </mat-form-field>
        </form>
        <div fxLayout="row" fxLayoutAlign="end center">
          @if (!isVerificationCodeSent) {
          <button mat-raised-button color="primary" (click)="onApproveAgreementClick()" [disabled]="!areAllRequiredConsentsChecked()">
            {{ 'WAD-SendVerificationCode' | translate }}
          </button>
          } @if (isVerificationCodeSent) {
          <button mat-raised-button color="primary" (click)="onVerifyAgreementCodeClick()" [disabled]="!isVerifyButtonEnabled()">
            {{ 'WAD-VerifyCode' | translate }}
          </button>
          }
        </div>
      </div>
      }
      <!-- Digital Signature Approval Section -->
      @if (isSignaturePadVisible()) {
      <div class="content-card">
        @if (isAgreementRelatedToUser) {
        <h2 class="content-card__header">{{ 'WAD-SignatureApproval' | translate }}</h2>
        <app-signature-pad></app-signature-pad>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button mat-raised-button color="accent" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
            {{ 'Clear' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="onSignAgreementClick()" [disabled]="!isSignatureValid">
            {{ 'WAD-SignAgreement' | translate }}
          </button>
        </div>
        } @else { @if (hasSignAgreementAsEmployerRepresentativePermission) {
        <h2 class="content-card__header">{{ 'WAD-SignatureApproval' | translate }}</h2>
        <mat-checkbox (change)="workerSignatureEnabled = $event.checked">
          {{ 'WAD-EnableSignatureApproval' | translate }}
        </mat-checkbox>
        @if (workerSignatureEnabled) {
        <app-signature-pad></app-signature-pad>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button mat-raised-button color="accent" (click)="onClearSignaturePadClick()" [disabled]="isSignaturePadEmpty">
            {{ 'Clear' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="onSignAgreementClick()" [disabled]="!isSignatureValid">
            {{ 'WAD-SignAgreement' | translate }}
          </button>
        </div>
        } } @else { @if (!agreement.IsSendToVerification) {
        <div>
          {{ 'WAD-SendMandateAgreementToVerificationInfo' | translate }}
        </div>
        } @else {
        <div>{{ 'WAD-AgreementInVerificationInfo' | translate }}</div>
        } } }
      </div>
      }
      <!-- Action Buttons -->
      <div fxLayoutAlign="space-between center" fxLayoutGap="10px" class="buttons-wrapper">
        @if (isLegalizationFieldForGeneratedVisible()) {
        <div [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']">
          <app-legalization-status-info
            [element]="workerAgreementLegalizationData"
            [size]="'large'"
            [showStatusText]="true"
            [showTooltip]="false"
            [showLabel]="true"
          ></app-legalization-status-info>
        </div>
        }
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          @if (isSendToCorrectionButtonVisible()) {
          <button mat-raised-button color="primary" (click)="onBackToEditAgreementClick()">
            {{ 'WAD-AgreementCorrection' | translate }}
          </button>
          } @if (isSendToApprovalButtonVisible()) {
          <button mat-raised-button color="primary" (click)="onSendToWorkerApprovalClick()">
            {{ 'WAD-SendToWorkerApproval' | translate }}
          </button>
          } @if (isSendToVerificationButtonVisible()) {
          <button mat-raised-button color="primary" (click)="onSendToVerificationApprovalClick()" [disabled]="agreement.IsSendToVerification">
            {{ 'WAD-SendToVerification' | translate }}
          </button>
          } @if (isApproveAgreementVoidingSectionVisible() === true) {
          <button mat-raised-button color="primary" (click)="onApproveAgreementVoidingClick()">
            {{ 'WAD-ApproveAgreementVoiding' | translate }}
          </button>
          }
        </div>
      </div>
    </form>
    }
  </div>
  }
</div>
